// Home Page Content - Extracted from nomu-marketing-website-guide.md
// Updated with modern React Icons

import { FaGlobe, FaMobileAlt, FaChartLine, FaCheckCircle, FaComments, FaClipboardList, FaCog, FaSync, FaRocket, FaBullseye, FaSmile, FaStar, FaAward, FaUsers } from 'react-icons/fa';
import { IoMdCheckmarkCircle } from 'react-icons/io';
import { MdSpeed, MdSecurity, MdLanguage, MdDevices } from 'react-icons/md';
import { BiSupport, BiTrendingUp } from 'react-icons/bi';
import { HiUserGroup, HiLightningBolt } from 'react-icons/hi';
import { BsGlobe2 } from 'react-icons/bs';

// Import portfolio images
import Website1 from '../images/Website1.jpg';
import Website2 from '../images/Website2.jpg';
import Website3 from '../images/Website3.jpg';
import Website4 from '../images/Website4.jpg';
import Website5 from '../images/Website5.jpg';
import Website6 from '../images/Website6.jpg';
import Website7 from '../images/Website7.jpg';

export const homeContent = {
  hero: {
    title: "نصمم حضورك الرقمي ونحوّل فكرتك إلى هوية ناجحة",
    subtitle: "نمو ماركتينج وكالة تسويق رقمية متخصصة في تصميم المواقع، إدارة السوشيال ميديا، والإعلانات الممولة. نساعدك تنمّي مشروعك وتوصل لعملائك باحترافية.",
    primaryButton: "ابدأ معنا اليوم",
    secondaryButton: "تصفح خدماتنا",
    imageUrl: "https://via.placeholder.com/800x600/1A4D5C/2DD4BF?text=Nomu+Marketing",
    imageAlt: "نمو ماركتينج - وكالة تسويق رقمية"
  },

  servicesSection: {
    title: "خدماتنا الرقمية المتكاملة",
    subtitle: "نقدم لك حلول تسويقية شاملة تساعدك على النمو والانطلاق بثقة",
    services: [
      {
        id: 1,
        icon: BsGlobe2,
        title: "تصميم المواقع الإلكترونية",
        description: "مواقع احترافية سريعة ومتجاوبة مع جميع الأجهزة",
        link: "/services/web-design"
      },
      {
        id: 2,
        icon: FaMobileAlt,
        title: "إدارة السوشيال ميديا",
        description: "إدارة حساباتك بمحتوى جذاب واحترافي",
        link: "/services/social-media"
      },
      {
        id: 3,
        icon: FaChartLine,
        title: "الإعلانات الممولة",
        description: "حملات إعلانية فعّالة تزيد مبيعاتك",
        link: "/services/paid-ads"
      }
    ]
  },

  whyUs: {
    title: "لماذا تختار نمو ماركتينج؟",
    features: [
      {
        id: 1,
        icon: IoMdCheckmarkCircle,
        title: "خبرة في السوق السعودي والإماراتي",
        description: "نفهم جمهورك ونتكلم لغته"
      },
      {
        id: 2,
        icon: HiLightningBolt,
        title: "تسليم سريع واحترافي",
        description: "نلتزم بالمواعيد ونحقق أعلى معايير الجودة"
      },
      {
        id: 3,
        icon: BiSupport,
        title: "دعم فني دائم",
        description: "فريقنا متاح لك على مدار الساعة"
      },
      {
        id: 4,
        icon: BiTrendingUp,
        title: "أسعار تنافسية وباقات مرنة",
        description: "حلول تناسب كل الميزانيات"
      }
    ]
  },

  howWeWork: {
    title: "رحلتك معنا في 5 خطوات بسيطة",
    steps: [
      {
        id: 1,
        number: "1",
        icon: FaComments,
        title: "تواصل معنا عبر واتساب",
        description: "شاركنا احتياجاتك وأهدافك"
      },
      {
        id: 2,
        number: "2",
        icon: FaClipboardList,
        title: "نحدد الباقة المناسبة",
        description: "نقترح عليك الحل الأمثل لمشروعك"
      },
      {
        id: 3,
        number: "3",
        icon: FaCog,
        title: "نبدأ العمل",
        description: "فريقنا يبدأ بتنفيذ مشروعك باحترافية"
      },
      {
        id: 4,
        number: "4",
        icon: FaSync,
        title: "مراجعة وتعديلات",
        description: "نستمع لملاحظاتك ونطور العمل"
      },
      {
        id: 5,
        number: "5",
        icon: FaRocket,
        title: "التسليم والانطلاق",
        description: "تستلم مشروعك جاهز للنجاح"
      }
    ]
  },

  portfolio: {
    title: "نماذج من أعمالنا",
    subtitle: "مشاريع حققت نجاح مع عملائنا",
    projects: [
      {
        id: 1,
        title: "موقع تجاري احترافي",
        category: "تصميم مواقع الأعمال",
        image: Website1
      },
      {
        id: 2,
        title: "منصة إلكترونية متكاملة",
        category: "تطوير مواقع ويب",
        image: Website2
      },
      {
        id: 3,
        title: "متجر إلكتروني عصري",
        category: "التجارة الإلكترونية",
        image: Website3
      },
      {
        id: 4,
        title: "موقع شركة حديث",
        category: "مواقع الشركات",
        image: Website4
      },
      {
        id: 5,
        title: "عيادات طبية",
        category: "تصميم وتطوير",
        image: Website5
      },
      {
        id: 6,
        title: "الحدائق والمزارع",
        category: "حلول الأعمال",
        image: Website6
      },
      {
        id: 7,
        title: "مراكز التجميل والسبا",
        category: "منصات رقمية",
        image: Website7
      },
      {
        id: 8,
        title: "إدارة السوشيال ميديا",
        category: "خدمات التسويق",
        image: "https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=1200&q=80"
      },
      {
        id: 9,
        title: "حملة إعلانية ناجحة",
        category: "الإعلانات الممولة",
        image: "https://images.unsplash.com/photo-1557838923-2985c318be48?w=1200&q=80"
      }
    ]
  },

  testimonials: {
    title: "آراء عملائنا",
    subtitle: "ماذا يقول عملاؤنا عنا",
    reviews: [
      {
        id: 1,
        rating: 5,
        text: "فريق محترف جداً وملتزم بالمواعيد. صمموا لي موقع متجري الإلكتروني وكانت النتيجة أكثر من رائعة!",
        authorName: "محمد العتيبي",
        authorTitle: "مالك متجر إلكتروني",
        location: "الرياض"
      },
      {
        id: 2,
        rating: 5,
        text: "خدمة إدارة السوشيال ميديا عندهم ممتازة. زاد التفاعل على حساباتنا بشكل كبير جداً.",
        authorName: "سارة القحطاني",
        authorTitle: "صاحبة مشروع تجميل",
        location: "جدة"
      },
      {
        id: 3,
        rating: 5,
        text: "الإعلانات الممولة اللي سووها لنا جابت نتائج فوق التوقعات. أنصح فيهم بقوة!",
        authorName: "عبدالله الدوسري",
        authorTitle: "مدير تسويق",
        location: "الدمام"
      },
      {
        id: 4,
        rating: 5,
        text: "تجربة ممتازة من البداية للنهاية. الفريق متعاون والتواصل سهل وسريع عبر الواتساب.",
        authorName: "فاطمة المطيري",
        authorTitle: "مديرة تسويق",
        location: "الكويت"
      },
      {
        id: 5,
        rating: 5,
        text: "صمموا لنا هوية كاملة للشركة وموقع إلكتروني متكامل. النتيجة تجاوزت توقعاتنا بكثير.",
        authorName: "خالد الشمري",
        authorTitle: "مدير عام شركة",
        location: "أبوظبي"
      },
      {
        id: 6,
        rating: 5,
        text: "أفضل وكالة تسويق رقمي تعاملت معها. فاهمين السوق الخليجي ويعرفون كيف يوصلون للجمهور.",
        authorName: "نورة السالم",
        authorTitle: "صاحبة مشروع",
        location: "دبي"
      },
      {
        id: 7,
        rating: 5,
        text: "العمل معهم كان سلس وسهل. سووا لنا حملة إعلانية ناجحة جداً وزادت مبيعاتنا بشكل ملحوظ.",
        authorName: "أحمد الحربي",
        authorTitle: "صاحب مطعم",
        location: "مكة"
      },
      {
        id: 8,
        rating: 5,
        text: "خدمة عملاء ممتازة ومتابعة مستمرة. دايماً متواجدين ويساعدونا في أي استفسار.",
        authorName: "ليلى عبدالله",
        authorTitle: "مديرة محتوى",
        location: "المنامة"
      },
      {
        id: 9,
        rating: 5,
        text: "موقعنا الجديد صار أسرع وأجمل. العملاء يمدحون فيه دايماً. شكراً لفريق نمو ماركتينج!",
        authorName: "يوسف التميمي",
        authorTitle: "مدير مبيعات",
        location: "الخبر"
      }
    ]
  },

  ourApproach: {
    title: "منهجيتنا في العمل",
    subtitle: "نتبع نهجاً علمياً ومدروساً لضمان نجاح مشروعك الرقمي",
    approaches: [
      {
        id: 1,
        icon: FaChartLine,
        title: "التحليل المبني على البيانات",
        description: "نستخدم أدوات تحليلية متقدمة لفهم السوق والجمهور واتخاذ قرارات مدروسة"
      },
      {
        id: 2,
        icon: IoMdCheckmarkCircle,
        title: "الجودة أولاً",
        description: "نلتزم بأعلى معايير الجودة في التصميم والتطوير والمحتوى"
      },
      {
        id: 3,
        icon: FaUsers,
        title: "التواصل المستمر",
        description: "نبقيك على اطلاع دائم بتقدم مشروعك ونستمع لملاحظاتك"
      },
      {
        id: 4,
        icon: FaRocket,
        title: "التحسين المستمر",
        description: "نراقب الأداء ونحسّن الاستراتيجيات باستمرار لتحقيق أفضل النتائج"
      }
    ]
  },

  guarantees: {
    title: "ضماناتنا لك",
    subtitle: "نلتزم بتقديم أفضل خدمة ونضمن رضاك التام",
    items: [
      {
        id: 1,
        icon: IoMdCheckmarkCircle,
        title: "ضمان الجودة 100%",
        description: "نضمن جودة عالية في كل ما نقدمه أو نعيد لك أموالك"
      },
      {
        id: 2,
        icon: BsGlobe2,
        title: "التسليم في الموعد",
        description: "نلتزم بالمواعيد المحددة ونسلم مشروعك في الوقت المتفق عليه"
      },
      {
        id: 3,
        icon: BiSupport,
        title: "دعم فني مجاني",
        description: "ندعمك بعد التسليم مجاناً حسب الباقة المختارة"
      },
      {
        id: 4,
        icon: FaAward,
        title: "رضا العملاء مضمون",
        description: "نعمل معك حتى تحصل على النتيجة التي تريدها تماماً"
      }
    ]
  },

  stats: {
    title: "إنجازاتنا بالأرقام",
    counters: [
      {
        id: 1,
        number: 150,
        suffix: "+",
        label: "مشروع ناجح",
        icon: FaBullseye
      },
      {
        id: 2,
        number: 120,
        suffix: "+",
        label: "عميل راضي",
        icon: FaSmile
      },
      {
        id: 3,
        number: 3,
        suffix: "",
        label: "سنوات خبرة",
        icon: FaStar
      },
      {
        id: 4,
        number: 98,
        suffix: "%",
        label: "نسبة رضا العملاء",
        icon: FaAward
      }
    ]
  },

  finalCTA: {
    title: "جاهز تبدأ مشروعك الرقمي؟",
    subtitle: "تواصل معنا الآن واحصل على استشارة مجانية",
    buttonText: "ابدأ الآن",
    backgroundStyle: "gradient"
  }
};
